<div class="relative" [class.pv-root]="viewMode() === 'payment'">

  @if (viewMode() === 'event') {
    <!-- ==================== EVENT VIEW ==================== -->
    @let ev = agendaEvent();
    <div class="ev" [class.ev--loading]="isLoadingData()" [attr.aria-busy]="isLoadingData()">

      <!-- Who -->
      <div class="ev-client">
        <span class="ev-avatar" aria-hidden="true">{{ clientInitials() }}</span>
        <div class="min-w-0 flex-1">
          <h3 class="ev-client__name">{{ ev.clientName }}</h3>
          @if (ev.clientPhone || ev.clientEmail) {
          <p class="ev-client__contact">
            @if (phoneHref()) {
            <a [href]="phoneHref()" class="ev-link">{{ ev.clientPhone }}</a>
            }
            @if (ev.clientEmail) {
            <span class="truncate">{{ ev.clientEmail }}</span>
            }
          </p>
          }
        </div>
        @if (ev.clientId) {
        <a [routerLink]="['/people', ev.clientId]" class="ev-link ev-client__profile">Ver ficha</a>
        }
      </div>

      <!-- When, what, with whom -->
      <div class="ev-when" [style.--pro-color]="professionalColor()">
        @if (start(); as s) {
        <p class="ev-when__day">{{ s | date: 'EEEE d \'de\' MMMM' }}</p>
        <p class="ev-when__time">
          {{ s | date: 'h:mm a' }} – {{ end() | date: 'h:mm a' }}
          @if (durationMinutes() > 0) {
          <span class="ev-when__duration">{{ formatDuration(durationMinutes()) }}</span>
          }
        </p>
        }
        <p class="ev-when__service">
          <strong>{{ ev.serviceName }}</strong>
          @if (ev.professionalName || ev.agendaName) {
          <span>con {{ ev.professionalName || ev.agendaName }}</span>
          }
        </p>
        @if (ev.totalSessions && ev.totalSessions > 1) {
        <p class="ev-when__session">Sesión {{ ev.sessionNumber }} de {{ ev.totalSessions }}</p>
        }
      </div>

      <!-- Status -->
      <div class="ev-block">
        <p class="ev-label" id="ev-status-label">Estado de la cita</p>
        <div class="ev-status" role="radiogroup" aria-labelledby="ev-status-label">
          @for (s of statusOptions(); track s.code) {
          <button type="button" role="radio" class="ev-status__opt" [style.--status-color]="s.color"
            [attr.aria-checked]="statusCode() === s.code" (click)="setStatus(s.code)"
            [disabled]="isSavingStatus() || statusCode() === s.code">
            <span class="ev-dot" aria-hidden="true"></span>
            {{ s.label }}
            @if (statusCode() === s.code && isSavingStatus()) {
            <svg class="size-3 motion-safe:animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
            }
          </button>
          }
        </div>
      </div>

      <!-- Notes -->
      @if (ev.notes) {
      <div class="ev-block">
        <p class="ev-label">Notas</p>
        <p class="ev-notes">{{ ev.notes }}</p>
      </div>
      }

      <!-- Money -->
      <div class="ev-block">
        <dl class="ev-price">
          @if (hasPromotion()) {
          <div>
            <dt>Precio del servicio</dt>
            <dd>{{ servicePrice() | currency:'COP':'symbol-narrow':'1.0-0' }}</dd>
          </div>
          <div class="ev-price__discount">
            <dt>
              Descuento
              @if (ev.promotionName) { <span>{{ ev.promotionName }}@if (promotionDisplay()) { ({{ promotionDisplay() }})}</span> }
            </dt>
            <dd>-{{ discountAmount() | currency:'COP':'symbol-narrow':'1.0-0' }}</dd>
          </div>
          }
          <div class="ev-price__total">
            <dt>Total</dt>
            <dd>{{ finalPrice() | currency:'COP':'symbol-narrow':'1.0-0' }}</dd>
          </div>
        </dl>
      </div>
    </div>

    <!-- Payment action -->
    <div class="ev-footer">
      @if (ev.paymentCompleted) {
      <span class="ev-paid">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
        Pagada
      </span>
      } @else {
      <span class="ev-unpaid">Pago pendiente</span>
      }
      <button type="button" class="ev-btn" [class.ev-btn--primary]="!ev.paymentCompleted"
        [class.ev-btn--ghost]="ev.paymentCompleted" (click)="triggerPaymentDrawer()" [disabled]="isLoadingData()">
        {{ ev.paymentCompleted ? 'Ver pago' : 'Registrar pago' }}
      </button>
    </div>

  } @else {
    <!-- ==================== PAYMENT VIEW ==================== -->
    @let ev = agendaEvent();

    <div class="pv-head">
      <button type="button" (click)="backToEventView()" class="pv-back" aria-label="Volver al detalle de la cita">
        <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <div class="min-w-0 flex-1">
        <h3 class="pv-head__title">Cobro de la cita</h3>
        <p class="pv-head__sub">{{ ev.clientName }}, {{ ev.serviceName }}</p>
      </div>
      @if (payment()) {
      <span class="pv-pill" [attr.data-state]="payState()">
        {{ payState() === 'paid' ? 'Pagada' : payState() === 'partial' ? 'Pago parcial' : 'Sin pagar' }}
      </span>
      }
    </div>

    @if (isPaymentLoading() && !payment()) {
      <div class="pv-skeleton" aria-hidden="true">
        <div></div><div></div><div></div>
      </div>
    } @else {

      <!-- ===== Account: what is being charged ===== -->
      <section class="pv-card" aria-label="Cuenta">
        <!-- Only the bill lines and the product catalog scroll; totals and the charge form stay in view -->
        <div class="pv-scroll">
        <ul class="pv-lines">
          <li>
            <span class="pv-lines__name">
              {{ ev.serviceName }}
              @if (ev.totalSessions && ev.totalSessions > 1) {
              <small>{{ ev.totalSessions }} sesiones de {{ getUnitPricePerSession() | currency:'COP':'symbol-narrow':'1.0-0' }}</small>
              }
            </span>
            <span class="pv-num">{{ servicePrice() | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </li>
          @if (hasPromotion()) {
          <li class="pv-lines__discount">
            <span class="pv-lines__name">
              Descuento
              <small>{{ ev.promotionName }}@if (promotionDisplay()) { ({{ promotionDisplay() }})}</small>
            </span>
            <span class="pv-num">-{{ discountAmount() | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </li>
          }
          @for (item of confirmedProducts(); track item.paymentDetailId) {
          <li>
            <span class="pv-lines__name">{{ item.itemName }} <small>× {{ item.quantity }}</small></span>
            <span class="pv-num">{{ item.total | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </li>
          }
          @for (item of selectedProducts(); track item.productId) {
          <li class="pv-lines__new">
            <span class="pv-lines__name">
              {{ getProductName(item.productId) }}
              <small>Por agregar</small>
            </span>
            <span class="pv-qty" role="group" [attr.aria-label]="'Cantidad de ' + getProductName(item.productId)">
              <button type="button" (click)="updateProductQuantity(item.productId, item.quantity - 1)"
                [attr.aria-label]="item.quantity === 1 ? 'Quitar producto' : 'Restar uno'">−</button>
              <span>{{ item.quantity }}</span>
              <button type="button" (click)="updateProductQuantity(item.productId, item.quantity + 1)"
                [disabled]="item.quantity >= getProductStock(item.productId)" aria-label="Sumar uno">+</button>
            </span>
            <span class="pv-num">{{ getProductItemTotal(item) | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </li>
          }
        </ul>

        <!-- Add products (only while the payment is still open) -->
        @if (canAddProducts()) {
        <div class="pv-products">
          <button type="button" class="pv-link" (click)="toggleProductSearch()" [attr.aria-expanded]="showProductSearch()">
            {{ showProductSearch() ? 'Cerrar productos' : '+ Agregar productos vendidos' }}
          </button>
          @if (showProductSearch()) {
          <div class="pv-search">
            <input type="search" [formControl]="productSearchForm.controls.searchTerm" placeholder="Buscar producto"
              class="pv-input" aria-label="Buscar productos" />
            @if (isSearchingProducts()) {
            <span class="pv-spinner pv-search__spin" aria-hidden="true"></span>
            }
          </div>
          @if (products().length === 0) {
          <p class="pv-muted">No hay productos con ese nombre.</p>
          } @else {
          <ul class="pv-catalog">
            @for (product of products(); track product.productId) {
            <li>
              <button type="button" (click)="addProduct(product)" [disabled]="product.stock === 0"
                [attr.aria-label]="'Agregar ' + product.name">
                <span class="pv-catalog__name">{{ product.name }}</span>
                <span class="pv-catalog__meta">
                  {{ product.price | currency:'COP':'symbol-narrow':'1.0-0' }}
                  <span [class.pv-low]="product.stock > 0 && product.stock <= 3">
                    {{ product.stock === 0 ? 'Agotado' : product.stock + ' disponibles' }}
                  </span>
                </span>
              </button>
            </li>
            }
          </ul>
          }
          }
        </div>
        }
        </div>

        <!-- Totals -->
        <dl class="pv-totals">
          <div class="pv-totals__total">
            <dt>Total</dt>
            <dd class="pv-num">{{ grandTotal() | currency:'COP':'symbol-narrow':'1.0-0' }}</dd>
          </div>
          @if (payment()) {
          <div class="pv-meter" role="img" [attr.aria-label]="'Pagado ' + paidPercent() + ' por ciento'">
            <span [style.width.%]="paidPercent()"></span>
          </div>
          <div>
            <dt>Pagado</dt>
            <dd class="pv-num pv-paid">{{ paidAmount() | currency:'COP':'symbol-narrow':'1.0-0' }}</dd>
          </div>
          @if (hasPendingAmount()) {
          <div class="pv-totals__due">
            <dt>Falta por pagar</dt>
            <dd class="pv-num">{{ pendingAmount() | currency:'COP':'symbol-narrow':'1.0-0' }}</dd>
          </div>
          }
          }
        </dl>
      </section>

      <!-- ===== Payment detail: abonos already registered ===== -->
      @if (installments().length) {
      <section class="pv-section" aria-labelledby="pv-installments">
        <h4 id="pv-installments" class="pv-section__title">Pagos recibidos</h4>
        <ul class="pv-history">
          @for (inst of installments(); track inst.installmentId) {
          <li>
            <span class="pv-history__method">{{ methodLabel(inst.method) }}</span>
            <span class="pv-history__date">
              {{ inst.createdAt | date: 'd MMM, h:mm a' }}
              @if (inst.notes) { <span class="pv-history__note">{{ inst.notes }}</span> }
            </span>
            <span class="pv-num">{{ inst.amount | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </li>
          }
        </ul>
      </section>
      }

      <!-- ===== Charge form ===== -->
      @if (hasPendingAmount()) {
      <section class="pv-section" aria-label="Registrar pago">
        <p class="pv-label pv-label--first" id="pv-method-label">Método de pago</p>
        <div class="pv-methods" role="radiogroup" aria-labelledby="pv-method-label">
          @for (method of methodOptions(); track method.value) {
          <button type="button" role="radio" (click)="selectPaymentMethod(method.value)"
            [attr.aria-checked]="selectedMethod() === method.value">
            <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" [attr.d]="method.icon" />
            </svg>
            <span>
              {{ method.label }}
              @if (method.value === 'credit') {
              <small>{{ availableCredit() | currency:'COP':'symbol-narrow':'1.0-0' }} disponibles</small>
              }
            </span>
          </button>
          }
        </div>

        <label class="pv-label" for="ev-amount">Monto a cobrar</label>
        <div class="pv-amount">
        <input id="ev-amount" type="text" inputmode="numeric" autocomplete="off" class="pv-input pv-input--amount"
          [class.pv-input--error]="enteredAmount() > 0 && amountError()"
          [value]="manualAmountDisplay()" (input)="onManualAmountInput($event)" (focus)="onAmountFocus($event)"
          (blur)="onAmountBlur($event)" [attr.aria-describedby]="amountError() ? 'pv-amount-error' : null" />
        <div class="pv-chips">
          <button type="button" (click)="setAmount(selectedMethod() === 'credit' ? Math.min(availableCredit(), pendingAmount()) : pendingAmount())"
            [attr.aria-pressed]="enteredAmount() === pendingAmount()">
            Todo lo pendiente
          </button>
          @if (pendingAmount() >= 2000) {
          <button type="button" (click)="setAmount(pendingAmount() / 2)"
            [attr.aria-pressed]="enteredAmount() === Math.round(pendingAmount() / 2)">
            La mitad
          </button>
          }
        </div>
        </div>
        @if (enteredAmount() > 0 && amountError()) {
        <p class="pv-error" id="pv-amount-error">{{ amountError() }}</p>
        } @else if (enteredAmount() > 0 && enteredAmount() < pendingAmount()) {
        <p class="pv-hint">Quedará pendiente {{ (pendingAmount() - enteredAmount()) | currency:'COP':'symbol-narrow':'1.0-0' }}.</p>
        }

        @if (showNote() || manualForm.controls.notes.value) {
        <label class="pv-label" for="pv-notes">Nota <span class="pv-optional">(opcional)</span></label>
        <input id="pv-notes" type="text" [formControl]="manualForm.controls.notes" class="pv-input"
          placeholder="Ej.: pagó con billete de 100 mil" />
        } @else {
        <button type="button" class="pv-link pv-note-toggle" (click)="showNote.set(true)">+ Agregar nota</button>
        }

        <button type="button" class="pv-submit" (click)="registerPayment()"
          [disabled]="!!amountError() || isPaymentLoading()">
          @if (isPaymentLoading()) {
          <span class="pv-spinner pv-spinner--light" aria-hidden="true"></span>
          Registrando pago…
          } @else {
          Cobrar {{ enteredAmount() | currency:'COP':'symbol-narrow':'1.0-0' }}
          }
        </button>
      </section>
      } @else if (isPaid()) {
      <section class="pv-done" aria-live="polite">
        <span class="pv-done__icon" aria-hidden="true">
          <svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </span>
        <p class="pv-done__title">Esta cita ya está pagada</p>
      </section>
      }

      <!-- ===== Receipts ===== -->
      @if (lastPaymentId() && paidAmount() > 0) {
      <ng-container *ngTemplateOutlet="receipts"></ng-container>
      }
    }

  }

  <!-- Receipt downloads -->
  <ng-template #receipts>
    <section class="pv-section" aria-labelledby="pv-receipts">
      <h4 id="pv-receipts" class="pv-section__title">Comprobante</h4>
      <div class="pv-receipts">
        <button type="button" class="pv-receipt" (click)="downloadReceipt('ticket')" [disabled]="isDownloadingReceipt()">
          @if (downloadingFormat() === 'ticket') {
          <span class="pv-spinner" aria-hidden="true"></span>
          } @else {
          <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 2h12v19l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5L6 21V2Z" />
            <path stroke-linecap="round" d="M9 7h6M9 11h6M9 15h3" />
          </svg>
          }
          <span>
            Tirilla de impresión
            <small>Rollo de 80 mm para impresora térmica</small>
          </span>
        </button>
        <button type="button" class="pv-receipt" (click)="downloadReceipt('half-letter')" [disabled]="isDownloadingReceipt()">
          @if (downloadingFormat() === 'half-letter') {
          <span class="pv-spinner" aria-hidden="true"></span>
          } @else {
          <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M14 3v5h5M9 13h6M9 17h6" />
          </svg>
          }
          <span>
            Comprobante en PDF
            <small>Media carta, dos por hoja</small>
          </span>
        </button>
      </div>
      <p class="pv-muted">El comprobante no es un documento fiscal.</p>
    </section>
  </ng-template>
</div>
